import axios from "axios";
import { BASE_URL } from "../../constant/staticUrl";
import axiosInstance from "../../utils/axiosInstance";
const API = axios.create({ baseURL: BASE_URL });

export const getAllLiveClasses = () =>
  axiosInstance.get(`/admin/live-class/get-all`);

export const createLiveClassApi = (formData) =>
  axiosInstance.post(`/admin/live-class/create`, formData);

export const getStaticLiveClassApi = () =>
  axiosInstance.get(`/dashboard/static-data`);

export const getAllTimetableApi = (formData) =>
  axiosInstance.get(`/admin/timetable/get-all`, formData);

export const uploadTimetableApi = (formData) =>
  axiosInstance.post(`/admin/timetable/upload`, formData);

export const deleteTimetableApi = (id) =>
  axiosInstance.delete(`/admin/timetable/delete/${id}`);

export const getPresignedUrlDocApi = (docId, docType) =>
  axiosInstance.get(
    `/generic/admin-open-file?docId=${docId}&docType=${docType}`
  );
